import {
  AnyAction,
  combineReducers,
  configureStore as createStore,
  Reducer,
} from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { rootReducers } from 'app/store/reducers';
import {
  mixpanelMiddleware,
  sentryMiddleware,
  websocketsMiddleware,
} from './middlewares';

export const createRootReducer = (): Reducer => {
  const appReducer = combineReducers({
    ...rootReducers,
  });

  return (state: AppState, action: AnyAction) => {
    if (action.type === 'auth/logout') {
      return appReducer(undefined, action);
    }
    return appReducer(state, action);
  };
};

export const configureStore = (preloadState?: Record<string, any>) =>
  createStore({
    reducer: createRootReducer(),
    preloadedState: preloadState,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware().concat([
        mixpanelMiddleware,
        websocketsMiddleware,
        sentryMiddleware,
      ]),
  });

export const store = configureStore();

const rootReducerType = combineReducers({
  ...rootReducers,
});

export type AppState = ReturnType<typeof rootReducerType>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch: () => AppDispatch = useDispatch;
export const useAppSelector: TypedUseSelectorHook<AppState> = useSelector;
